import React, { useEffect, useState } from "react";
import { getAllEmployees } from "../../../../api/hrDashboard";

const LeaveRequests = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Modal State
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [actionType, setActionType] = useState(null); // 'approve' or 'reject'
  const [rejectReason, setRejectReason] = useState("");

  useEffect(() => {
    getAllEmployees()
      .then((res) => {
        const data = (res.data || [])
          .filter(e => !e.deboardEmp)
          .slice(0, 5)
          .map(e => ({
            initials: `${(e.firstName||"?")[0]}${(e.lastName||"?")[0]}`.toUpperCase(),
            name: `${e.firstName||""} ${e.lastName||""}`.trim() || "Employee",
            role: e.designationName || "Staff",
            dates: "15 Apr – 18 Apr",
            type: "Sick Leave",
            days: "3 Days",
          }));
        setEmployees(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const openActionModal = (index, type) => {
    setSelectedIndex(index);
    setActionType(type);
    setModalOpen(true);
    setRejectReason("");
  };

  const closeModal = () => {
    setModalOpen(false);
    setActionType(null);
    setRejectReason("");
  };

  const handleFinalAction = () => {
    console.log(
      `Finalizing ${actionType} for ${employees[selectedIndex].name}. Reason: ${rejectReason}`
    );
    closeModal();
  };

  const emp = selectedIndex !== null ? employees[selectedIndex] : null;

  return (
    <>
      <style>{`
        .lr-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; padding: 16px; width: 100%; box-sizing: border-box; }
        .lr-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
        .lr-title { font-weight: 700; font-size: 14px; color: #1e293b; }
        .lr-badge { background: #eff6ff; color: #2E5CB8; font-size: 11px; font-weight: 700; padding: 2px 10px; border-radius: 20px; }
        
        .lr-table { width: 100%; border-collapse: collapse; }
        .lr-th { text-align: left; font-size: 10px; color: #9ca3af; font-weight: 700; text-transform: uppercase; padding-bottom: 10px; border-bottom: 1px solid #f3f4f6; }
        .lr-row td { padding: 12px 0; border-bottom: 1px solid #f9fafb; font-size: 12px; vertical-align: middle; }
        
        .lr-emp { display: flex; align-items: center; gap: 10px; }
        .lr-avatar { width: 32px; height: 32px; border-radius: 50%; background: #e0e7ff; color: #4f6ef7; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 10px; }
        
        .lr-action-btn { width: 30px; height: 30px; border-radius: 8px; border: none; cursor: pointer; color: #fff; display: inline-flex; align-items: center; justify-content: center; margin-left: 5px; }
        .bg-green { background: #22c55e; }
        .bg-red { background: #ef4444; }

        .m-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; z-index: 9999; padding: 20px; }
        .m-box { background: #fff; width: 100%; max-width: 380px; border-radius: 20px; overflow: hidden; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); }
        
        .m-header { padding: 16px; background: #22c55e; color: #fff; display: flex; align-items: center; justify-content: space-between; font-weight: 700; }
        .m-header.reject-mode { background: #ef4444; }
        
        .m-body { padding: 24px; text-align: center; }
        
        .btn-base { padding: 12px; border-radius: 12px; border: none; font-weight: 600; cursor: pointer; font-size: 14px; transition: background 0.2s; }
        .btn-confirm-approve { background: #22c55e; color: #fff; }
        .btn-confirm-approve:hover { background: #16a34a; }
        .btn-confirm-reject { background: #ef4444; color: #fff; }
        .btn-confirm-reject:hover { background: #dc2626; }
        .btn-confirm-reject:disabled { opacity: 0.5; cursor: not-allowed; }

        .m-textarea { width: 100%; margin-top: 15px; padding: 12px; border: 1px solid #e2e8f0; border-radius: 10px; min-height: 90px; outline: none; font-family: inherit; font-size: 13px; box-sizing: border-box; }

        @media (max-width: 600px) {
          .hide-mobile { display: none; }
        }
      `}</style>

      <div className="lr-card">
        <div className="lr-header">
          <span className="lr-title">Pending Leave Requests</span>
          <span className="lr-badge">{employees.length} Pending</span>
        </div>

        <table className="lr-table">
          <thead>
            <tr>
              <th className="lr-th">Employee</th>
              <th className="lr-th hide-mobile">Dates</th>
              <th className="lr-th">Action</th>
            </tr>
          </thead>
          <tbody>
            {employees.map((e, i) => (
              <tr key={i} className="lr-row">
                <td>
                  <div className="lr-emp">
                    <div className="lr-avatar">{e.initials}</div>
                    <div>
                      <div style={{fontWeight:600}}>{e.name}</div>
                      <div style={{fontSize:10, color:'#94a3b8'}}>{e.role}</div>
                    </div>
                  </div>
                </td>
                <td className="hide-mobile">{e.dates}</td>
                <td>
                  <button className="lr-action-btn bg-green" onClick={() => openActionModal(i, 'approve')}>✓</button>
                  <button className="lr-action-btn bg-red" onClick={() => openActionModal(i, 'reject')}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modalOpen && emp && (
        <div className="m-overlay" onClick={closeModal}>
          <div className="m-box" onClick={e => e.stopPropagation()}>
            
            <div className={`m-header ${actionType === 'reject' ? 'reject-mode' : ''}`}>
              <span>{actionType === 'approve' ? 'Confirm Approval' : 'Reject Request'}</span>
              <button onClick={closeModal} style={{background:'none', border:'none', color:'#fff', cursor:'pointer', fontSize:18}}>✕</button>
            </div>

            <div className="m-body">
              
              <div style={{fontSize:15, fontWeight:700, color:'#1e293b'}}>
                {actionType === 'approve'
                  ? 'Are you sure you want to confirm?'
                  : 'Reason for rejection'}
              </div>

              <p style={{fontSize:13, color:'#64748b', marginTop:6}}>
                {actionType === 'approve'
                  ? <>Click OK to confirm approval for <strong>{emp.name}</strong>.</>
                  : <>Please provide a reason to reject <strong>{emp.name}</strong>'s leave.</>
                }
              </p>

              {actionType === 'reject' && (
                <textarea
                  className="m-textarea"
                  placeholder="Please provide a reason for rejection..."
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                />
              )}

              <div style={{ marginTop: 20 }}>
                <button
                  className={`btn-base ${actionType === 'approve' ? 'btn-confirm-approve' : 'btn-confirm-reject'}`}
                  style={{ width: '100%' }}
                  disabled={actionType === 'reject' && !rejectReason.trim()}
                  onClick={handleFinalAction}
                >
                  OK
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeaveRequests;